import React from 'react';
import { TableBody as TableBodyMaterial, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => {
  return {
    tableBody: {
      '& tr:nth-child(odd)': {
        backgroundColor: theme.palette.baseColors.tableGrey
      }
    }
  };
});

interface Props {
  children: any;
}

const TableBody = ({ children }: Props) => {
  const classes = useStyles();
  return (
    <TableBodyMaterial className={classes.tableBody}>
      {children}
    </TableBodyMaterial>
  );
};

export default TableBody;
